<template>
  <div
    class="my-2 mx-5"
  >
    <common-skeleton v-if="loading"></common-skeleton>
    <div v-if="listDailyLog && listDailyLog.length && !loading" id="style-2" style="max-height: 210px; overflow-y: auto">
      <div class="d-flex mb-2 custom-s-screen" v-for="item in listDailyLog" :key="item.id">
        <div class="highlight-box" :style="`border-left: 4px solid ${getColorByHighlightType(item.highlight_type).border}; background: ${getColorByHighlightType(item.highlight_type).background}`">
          <div class="d-flex">
            <div class="mr-3 highlight-type text-no-wrap" :style="`color: ${getColorByHighlightType(item.highlight_type).color}`">
              {{MAP_NOTIFICATION[item.type].text}}
            </div>
            <div v-html="item.content">
            </div>
            <span v-if="[HIGHLIGHT_TYPE.STUDENT_OFF_TICKET, HIGHLIGHT_TYPE.RESERVE].includes(item.highlight_type) && !checkHighlightText(item.content)" class="ml-2" style="color: #0180C7;text-decoration-line: underline;cursor: pointer;" @click="showNotivation(item)">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <img v-on="on" v-bind="attrs" src="../../assets/detail-highlight-icon.svg" height="14" width="14" alt="" class="ml-2">
                </template>
                <span>Xem chi tiết</span>
              </v-tooltip>
            </span>
          </div>
          <div class="d-flex mt-1">
            <div class="program-name" :style="`color: ${getColorByHighlightType(item.highlight_type).color}`">
              {{item.product}}
              <div class="ml-1" v-if="item.curriculum_id && mapProgramIdAndProgram[item.curriculum_id]">
                - {{ mapProgramIdAndProgram[item.curriculum_id].title}}
              </div>
              <div class="ml-1" v-else-if="item.subject_id">
                - {{ getSubjectById(item.subject_id).name}}
              </div>
            </div>
            <div class="ml-3 mr-3">
              <v-icon :color="`${getColorByHighlightType(item.highlight_type).color}`">mdi-circle-small</v-icon>
            </div>
            <div style="font-size: 12px">
              {{moment(item.created_at).format('DD/MM/YYYY HH:mm')}}
            </div>
          </div>
        </div>
<!--        <svg-->
<!--          width="12"-->
<!--          height="12"-->
<!--          viewBox="0 0 12 12"-->
<!--          fill="none"-->
<!--          xmlns="http://www.w3.org/2000/svg"-->
<!--          class="my-auto"-->
<!--        >-->
<!--          <rect-->
<!--            width="8.14928"-->
<!--            height="8.14928"-->
<!--            transform="matrix(0.721034 0.692899 -0.721034 0.692899 5.9043 0)"-->
<!--            :fill="item.type === 1 ? '#6C9200' : '#D44700'"-->
<!--          />-->
<!--        </svg>-->
<!--        <span class="mx-2 content-text-broad content-date">{{formatDate(item.created_at)}}</span>-->
<!--        <span-->
<!--          class="mr-2 content-text-broad"-->
<!--          :style="{ color: MAP_NOTIFICATION[`${item.type}`].color }"-->
<!--          >{{ MAP_NOTIFICATION[`${item.type}`].text }}</span-->
<!--        >-->
<!--        <span class="content-text-broad content-text">{{ item.content }}</span>-->
      </div>
    </div>
    <div v-if="listDailyLog && !listDailyLog.length && !loading" class="d-flex flex-column justify-center align-center w-100" style="margin-top: 60px">
      <img src="../../assets/close-icon.png" alt="" class="mb-2">
      <img src="../../assets/no-data-exercise.png" alt="" class="mb-5">
      <span style="color: #828282">
          Học sinh chưa có thông báo !
        </span>
    </div>
<!--    <div  style="margin: auto; width:fit-content">-->
<!--      <div style="text-align: center">-->
<!--        <img src="/img/search-results.png" alt="" style="width: 20%" />-->
<!--      </div>-->
<!--      <div style="text-align: center">-->
<!--        <span class="content-none">Không có thông tin nào gần đây</span>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import mapSubject from '@/mixins/mapSubject';
import { mapGetters, mapState } from 'vuex';
import BlendedCareServices from '@/services/BlendedCareRepository';
import { MAP_NOTIFICATION, HIGHLIGHT_TYPE } from '@/modules/student_detail_bt/const';
import * as moment from 'moment';

export default {
  computed: {
    ...mapState('student_detail_bt', ['filterForm', 'studentBlendedTutorDetail']),
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
  },
  mixins: [mapSubject],
  data() {
    return {
      listDailyLog: [],
      loading: false,
      MAP_NOTIFICATION,
      HIGHLIGHT_TYPE,
      moment,
    };
  },
  async created() {
    await this.getDetailStudent();
  },
  watch: {
    'filterForm.dateTime': {
      handler(val) {
        if (val && val.length) {
          this.getDetailStudent();
        }
      },
    },
  },
  methods: {
    checkHighlightText(text) {
      return text.includes('đã được hủy');
    },
    getColorByHighlightType(highlightType) {
      if (highlightType === HIGHLIGHT_TYPE.TUTOR_STUDY_NOT_JOIN || highlightType === HIGHLIGHT_TYPE.DUO_STUDY_NOT_JOIN) {
        return {
          border: '#E81E2F',
          color: '#F85866',
          background: '#FFF5F8',
        };
      } if (highlightType === HIGHLIGHT_TYPE.TUTOR_STUDY_LATE || highlightType === HIGHLIGHT_TYPE.TUTOR_STUDY_EARLY_LEAVE || highlightType === HIGHLIGHT_TYPE.DUO_STUDY_EARLY_LEAVE || highlightType === HIGHLIGHT_TYPE.DUO_STUDY_LATE) {
        return {
          border: '#FCA67C',
          color: '#FB8D57',
          background: '#FFF5ED',
        };
      }
      return {
        border: '#979799',
        color: '#707075',
        background: '#F5F4FC',
      };
    },
    async getDetailStudent() {
      if (this.studentBlendedTutorDetail.lms_core_user_id) {
        this.loading = true;
        if (!this.filterForm.dateTime.length) return;
        const res = await BlendedCareServices.getDailyLog({
          reportStartDate: this.filterForm.dateTime[0],
          reportEndDate: this.filterForm.dateTime[1],
          lmsCoreUserId: this.studentBlendedTutorDetail.lms_core_user_id,
        });
        if (res && res.data) {
          this.listDailyLog = res.data;
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: 'Có lỗi xảy ra. Vui lòng thử lại!',
          });
        }
        this.loading = false;
      }
    },
    formatDate(date) {
      if (date) {
        return moment(date)
          .format('DD/MM/YYYY - HH:mm');
      }
      return '';
    },
    showNotivation(item) {
      const routeData = `${process.env.VUE_APP_ERP}/tutor/ticket?id=${item.so_ticket_id}&studentId=${item.student_id}`;
      window.open(routeData, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.content-text-broad {
  color: #333;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 153.846% */
}
.content-none {
  color: #000;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 123.077% */
}
.content-date {
  width: 12%;
}
.content-text {
  width: 70%;
}
.custom-s-screen {
  svg {
    margin-top: 4px !important;
  }
}

@media screen and (max-width: 1440px) {
 .custom-s-screen {
   svg {
    margin-top: 4px !important;
   }
   .content-date {
    width: 15%;
   }
   .content-text {
    width: 70%;
   }
 }
}
.highlight-box {
  border-left: 4px solid red;
  padding: 6px 16px 0px 16px;
  background: #FFF5F8;
  width: fit-content;
  border-radius: 0 5px 5px 0;
}
.highlight-type {
  font-weight: bold;
  font-size: 14px;
}
.program-name {
  display: flex;
  font-size: 12px;
  font-weight: bold;
}
</style>
